export const FP_HDR_DIFF_TIMEOUT = 10 * 1000; // 10 seconds
export const CAPTURE_TIMEOUT = 30 * 1000; // 30 seconds
export const RETRY_TIMEOUT = 30 * 1000; // 30 seconds
export const RETRY_INTERVAL = 300; // 300 ms
export const RETRY_COUNT = Math.max(1, Math.floor(RETRY_TIMEOUT / RETRY_INTERVAL)); // 100x
export const E_RUNNING_ERROR = 'Timeout Error';
